// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__38IVH","footer":"ChangeClinic_footer__3VGfC"};